<template>
  <div class="col-sm-6 col-md-4 col-lg-3 mt-4">
    <div class="card" :class="hasStock === false ? 'disabled-card' : ''">
      <div class="profile">
        <span class="profile-avatar">{{ price }}</span>
      </div>

      <div class="profile-right">
        <span class="profile-avatar">{{ product.stock_quantity }} un.</span>
      </div>

      <img
        v-if="product.img"
        alt="imagem do produto"
        @click="addProductToCart(product)"
        class="card-img-top"
        :src="product.img"
      />
      <img
        v-else
        alt="imagem do produto não encontrada"
        style="object-fit: cover"
        @click="addProductToCart(product)"
        class="card-img-top"
        src="./../../assets/images/default-product-image.png"
      />
      <div class="card-block d-flex justify-content-center card-text">
        <h4 class="card-title mt-3 text-center truncate-overflow">
          {{ product.name }}
        </h4>
      </div>

      <div class="card-footer d-flex justify-content-between">
        <button
          type="button"
          class="button remove-button btn btn-circle btn-lg"
          @click="removeFromCart(product)"
        >
          <font-awesome-icon icon="minus" />
        </button>

        <span class="count-button btn btn-circle btn-xl">{{
          product.quantity
        }}</span>

        <button
          type="button"
          @click="addProductToCart(product)"
          class="button add-button btn btn-circle btn-lg"
        >
          <font-awesome-icon icon="plus" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from "vuex";

  export default {
    name: "Product",
    props: ["product"],

    async mounted() {
      this.price = window.formatToReal(this.product.price);
      this.cartQuantity = await this.getProductQuantity(this.product);
    },
    computed: {
      hasStock() {
        return this.product.stock_quantity > 0;
      },
    },
    data() {
      return {
        price: 0,
        cartQuantity: 0,
      };
    },

    methods: {
      ...mapActions({
        _addProductToCart: "addProductToCart",
        removeFromCart: "removeFromCart",
        getProductQuantity: "getProductQuantity",
      }),

      async addProductToCart(product) {
        try {
          await this._addProductToCart(product);
        } catch (e) {
          this.$swal({
            title: e.message,
            type: "warning",
            confirmButtonText: "Entendi",
          });
        }
      },
    },
  };
</script>

<style scoped>
  .truncate-overflow {
    --lh: 2rem;
    --max-lines: 2;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    position: absolute;
    max-height: calc(var(--lh) * var(--max-lines));
    text-align: center;
  }

  .card {
    font-size: 1em;
    overflow: hidden;
    padding: 0;
    border: none;
    border-radius: 15px;
    box-shadow: 0 1px 3px 0 #d4d4d5, 0 0 0 1px #d4d4d5;
  }

  .disabled-card {
    display: none;
    pointer-events: none;
  }

  .card-block {
    font-size: 1em;
    position: relative;
    margin: 0;
    border: none;
    border-top: 1px solid rgba(34, 36, 38, 0.1);
    box-shadow: none;
    background-color: var(--light-orange);
  }

  .card-text {
    height: 100px;
  }

  .card-img-top {
    display: block;
    width: 100%;
    height: 250px;
  }

  .card-title {
    font-size: 25px;
    line-height: 1.2857em;
  }

  .card-footer {
    font-size: 1em;
    position: static;
    top: 0;
    left: 0;
    max-width: 100%;
    padding: 0.75em 1em;
    color: rgba(0, 0, 0, 0.4);
    border-top: 1px solid rgba(0, 0, 0, 0.05) !important;
    background: var(--light-orange);
  }

  .profile {
    padding: 0 5px;
    position: absolute;
    top: 5px;
    left: 5px;
    display: inline-block;
    overflow: hidden;
    margin: 0;
    border: 3px solid var(--dark-orange);
    background-color: var(--background);
    border-radius: 15px;
  }

  .profile-right {
    padding: 0 5px;
    position: absolute;
    top: 5px;
    display: inline-block;
    overflow: hidden;
    left: auto;
    right: 5px;
    border: 3px solid var(--dark-orange);
    background-color: var(--background);
    border-radius: 15px;
  }

  .profile-avatar {
    display: block;
    width: 100%;
    font-weight: bold;
    font-size: 20px;
    color: var(--dark-orange);
  }

  .profile-inline ~ .card-title {
    display: inline-block;
    margin-left: 4px;
    vertical-align: top;
  }

  .btn-circle {
    width: 30px;
    height: 30px;
    text-align: center;
    padding: 6px 0;
    font-size: 12px;
    line-height: 1.428571429;
    border-radius: 15px;
    color: #fff;
  }

  .add-button {
    background-color: var(--light-green);

    float: right;
  }

  .count-button {
    background-color: var(--dark-orange);
    font-size: 40px !important;
    padding: 5px !important;
  }

  .count-button:hover {
    letter-spacing: 1px;
    box-shadow: 5px 40px -10px rgba(0, 0, 0, 0.57);
    transition: all 0.4s ease 0s;
    color: #fff;
  }

  .remove-button {
    background-color: var(--red);
    float: left;
  }

  .btn-circle.btn-lg {
    width: 50px;
    height: 50px;
    padding: 10px 16px;
    font-size: 18px;
    line-height: 1.33;
    border-radius: 25px;
  }

  .btn-circle.btn-xl {
    width: 70px;
    height: 70px;
    padding: 10px 16px;
    font-size: 24px;
    line-height: 1.33;
    border-radius: 35px;
  }

  .button {
    position: relative;
    font-size: 28px;
    color: #ffffff;
    padding: 20px;
    width: 200px;
    text-align: center;
    -webkit-transition-duration: 0.4s; /* Safari */
    transition-duration: 0.4s;
    text-decoration: none;
    overflow: hidden;
    cursor: pointer;
  }

  .remove-button:after {
    content: "";
    background: #90ee90;
    display: block;
    position: absolute;
    padding-top: 300%;
    padding-left: 350%;
    margin-left: -20px !important;
    margin-top: -120%;
    opacity: 0;
    transition: all 0.8s;
  }

  .add-button:after {
    content: "";
    background: orange;
    display: block;
    position: absolute;
    padding-top: 300%;
    padding-left: 350%;
    margin-left: -20px !important;
    margin-top: -120%;
    opacity: 0;
    transition: all 0.8s;
  }

  .button:active:after {
    padding: 0;
    margin: 0;
    opacity: 1;
    transition: 0s;
  }

  .button:hover {
    color: #fff;
  }
</style>
